var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.000000pt",
    height: "20.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2300 4144 c-25 -3 -114 -16 -199 -30 -279 -46 -524 -127 -801 -265 -433 -217 -800 -519 -1110 -917 -163 -210 -197 -282 -187 -398 6 -84 38 -147 144 -289 406 -540 927 -926 1528 -1132 270 -92 502 -133 806 -140 238 -6 378 3 569 38 716 128 1389 548 1874 1170 168 216 203 289 193 405 -6 84 -38 147 -144 289 -506 674 -1188 1107 -1955 1241 -135 23 -184 27 -413 29 -143 2 -280 1 -305 -1z m377 -515 c663 -74 1102 -728 917 -1365 -103 -357 -381 -635 -738 -738 -374 -109 -778 -4 -1056 274 -421 421 -421 1100 0 1520 129 130 291 225 468 275 147 42 257 51 409 34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2435 3245 c-99 -18 -175 -49 -259 -106 -229 -153 -349 -423 -304 -684 20 -117 49 -189 109 -280 207 -309 615 -402 936 -214 73 43 198 168 242 242 189 321 93 736 -217 938 -156 102 -329 137 -507 104z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.bd2e4b2d856fb27eccfb4ababef99f4d.svg";
export { ForwardRef as ReactComponent };